






import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";
import { ContentMixin } from "./mixins";

@Component
export default class WizardContentFixedTextIndicator extends Mixins(ContentMixin) {
  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "";
  }
}
